import React, { useEffect, useState, useContext } from 'react';
import { fetchTenantInfo, getPaymentMethod, getSurchargesAmount, signout } from '@v10-codeparva/v10-tfw-revamp-package-api';
import { getIndivCookie, deleteCookie } from '../../../utils/auth';
import { AutoPaySyrapay } from '../autoPaySyrapay/AutoPaySyrapay';
import { Spinner } from '@chakra-ui/react';
import { navigate } from '@reach/router';
import { FacilityContext } from "components/context";
import { AutoPayWorldPay } from '../autoPayWorldpay/AutoPayWorldpay';
import Loader from './Loader';

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
};

export const AutoPayPage = ({ loction }: { location: any }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [apiResponse, setApiResponse] = useState<any>();
    const cToken = getIndivCookie('cToken');
    const facilityContext = useContext<any>(FacilityContext);

    useEffect(() => {
        let unMounted = false;
        async function fetchDetails() {
            const requestBody = {
                token: cToken || '',
                cid: process.env.CID || '',
            }
            const tenantDetails = await fetchTenantInfo(requestBody);
            const paymentMethodDetails = await getPaymentMethod(process.env.CID || '');
            const {
                Tenant
            } = tenantDetails;
            const lstPayTypes = paymentMethodDetails.lstPayTypes.filter((payType) => payType.IsCreditCard)

            const responseState = {
                Tenant,
                lstPayTypes,
            }
            setApiResponse(responseState);
            setIsLoading(false);
        };
        try {
            if (!unMounted) {
                fetchDetails()
            }
        } catch (e) {
            if (!unMounted) {
                console.error(e);
            }
        }
    }, [])


    const signOutHandler = async () => {
        const requestBody = {
            token: cToken || '',
            cid: process.env.CID || '',
        }
        const signOutResponse = await signout(requestBody);
        const {
            blnSuccess
        } = signOutResponse;
        if (blnSuccess) {
            deleteCookie('cToken');
            navigateTo('payment')
        }
    };

    const RenderComponent = () => {
        const { datoCmsFacilityDetails = {} } = facilityContext;
        const autoPaySyrapayProps = {
            cardList: apiResponse.lstPayTypes,
            existingCardDetails: {
                CCNumber: apiResponse.Tenant.CCNumber,
                CCBillingAccountName: apiResponse.Tenant.CCBillingAccountName,
                CCExpirationMonth: apiResponse.Tenant.CCExpirationMonth,
                CCExpirationYear: apiResponse.Tenant.CCExpirationYear,
                CCBillingAddress: apiResponse.Tenant.CCBillingAddress,
                CCBillingZIP: apiResponse.Tenant.CCBillingZIP
            },
            logOffHandler: signOutHandler,
            IsAutoPaymentsEnabled: apiResponse.Tenant.IsAutoPaymentsEnabled,
            PreferredPaymentMethod: apiResponse.Tenant.PreferredPaymentMethod,
            IsAutoPaymentsForced: apiResponse.Tenant?.IsAutoPaymentsForced || false,
            IsOptingOutAutoPaymentRestricted: datoCmsFacilityDetails.isOptingOutAutoPaymentRestricted,
        }

        return (
            <>
                {
                    facilityContext?.datoCmsFacilityDetails.payementGatewaySelection === 'syrapay' ?
                        <AutoPaySyrapay
                            {...autoPaySyrapayProps}
                        /> :
                        <AutoPayWorldPay
                            {...autoPaySyrapayProps}
                        />
                }
            </>
        )
    }
    return <>{isLoading ? <Loader /> : <RenderComponent />}</>;

};